// ═══════════════════════════════════════════════════════════════
// ClearView CRM App Configuration
// ═══════════════════════════════════════════════════════════════

export const APP_VERSION = "2.1";
export const APP_NAME = "ClearView Philanthropy CRM";
export const STORAGE_KEY = "cmm_data";
export const SETTINGS_KEY = "cmm_settings";
export const BACKUP_PREFIX = "CMM_Backup";

// Single-tenant chapter ID for PCPA instance
// Used as chapter_id on show sponsorship tables
export const CHAPTER_ID = "00000000-0000-0000-0000-000000000001";

export const FONT_FAMILY = "'Segoe UI', system-ui, -apple-system, sans-serif";
export const FONT_SIZES = {
  xs: "0.75rem", // 12px — badges, timestamps, meta text (minimum readable)
  sm: "0.875rem", // 14px — body text, form inputs, descriptions
  md: "1rem", // 16px — subheadings, section headers
  lg: "1.125rem", // 18px — headings, panel titles
  xl: "1.375rem", // 22px — page/view titles
  xxl: "1.75rem", // 28px — hero numbers, major titles
  xxxl: "2.25rem", // 36px — extra large display
};

// Icon sizes — use these as `size={ICON_SIZES.md}` on lucide-react
// icons throughout the app so visual weight stays consistent.
//
// The exported object is a Proxy over a mutable scale factor so that
// a user-level "Icon Size" preference can grow or shrink every icon
// at once without rewriting every consumer. Components that read
// ICON_SIZES.md during render will see the current scaled value.
const ICON_SIZE_BASE = {
  xs: 11, // info bubbles, tiny badges
  sm: 14, // inline field icons, chip icons
  md: 18, // standard button icons (ActionButton, solid/pill toolbar)
  lg: 22, // section headers, sidebar accents
  xl: 26, // primary toolbar / navigation (icon-dot style)
  xxl: 36, // hero / empty-state illustrations
};

// Integer percentage (100 = default, 85 = compact, 115 = large, 130 = extra large)
let _iconScalePct = 100;

export const getIconScale = () => _iconScalePct;

// Mutating the scale doesn't trigger React re-renders on its own —
// callers should pair this with a context state change so consumers
// re-render and read the proxy's new values during their next render.
export const setIconScale = (pct) => {
  const n = Number(pct);
  _iconScalePct = Number.isFinite(n) && n > 0 ? Math.round(n) : 100;
};

export const ICON_SIZES = new Proxy(ICON_SIZE_BASE, {
  get(target, key) {
    if (key in target) {
      return Math.round((target[key] * _iconScalePct) / 100);
    }
    return undefined;
  },
});

// Preset scales offered in Settings → Appearance
export const ICON_SCALE_OPTIONS = [
  { id: 85, label: "Compact" },
  { id: 100, label: "Default" },
  { id: 115, label: "Large" },
  { id: 130, label: "Extra Large" },
];

export const TOOLBAR_STYLES = [
  {
    id: "icon-dot",
    name: "Icon Forward",
    desc: "Large icons with color indicator dots",
  },
  {
    id: "solid",
    name: "Solid Buttons",
    desc: "Filled accent color with white text",
  },
  { id: "pill", name: "Color Pills", desc: "Rounded colored pill buttons" },
];
